/**
 * Keep fixed header logos aligned with the mobile visual viewport.
 * Mount page nav pill sections into the header row so pills stay level with the logo.
 */
(function () {
  var viewportTargets = document.querySelectorAll('.header-home-nav, .header-logo-blend');
  var pillVarNames = ['--home-nav-pill-gap', '--home-nav-pill-text', '--home-nav-pill-bg'];

  function copyPillVars(fromEl, toEl) {
    if (!fromEl || !toEl) return;

    var styles = window.getComputedStyle(fromEl);
    pillVarNames.forEach(function (name) {
      var value = styles.getPropertyValue(name);
      if (value) toEl.style.setProperty(name, value.trim());
    });
  }

  function mountHeaderNavPills() {
    var logoNav = document.querySelector('.header-home-nav');
    if (!logoNav) return;

    document.querySelectorAll('.section-header-nav-pills').forEach(function (pillSection) {
      var pillsBar = pillSection.querySelector('.header-nav-pills-bar');
      if (!pillsBar) return;

      if (pillsBar.parentElement === logoNav) return;

      copyPillVars(pillSection, logoNav);

      if (logoNav.classList.contains('header-home-nav--shop')) {
        var cart = logoNav.querySelector('.header-home-nav__shop-cart');
        if (cart) {
          logoNav.insertBefore(pillsBar, cart);
        } else {
          logoNav.appendChild(pillsBar);
        }
      } else {
        logoNav.appendChild(pillsBar);
      }

      pillSection.setAttribute('data-pills-mounted', 'true');
      pillSection.setAttribute('aria-hidden', 'true');
      pillSection.hidden = true;
    });
  }

  function syncLogoPosition() {
    if (!window.visualViewport) return;

    var offsetTop = Math.max(0, window.visualViewport.offsetTop);
    viewportTargets.forEach(function (target) {
      target.style.setProperty('--visual-viewport-offset', offsetTop + 'px');
    });
  }

  function syncHeaderLayout() {
    mountHeaderNavPills();
    syncLogoPosition();
  }

  if (!document.querySelector('.header-home-nav')) return;

  syncHeaderLayout();

  if (window.visualViewport) {
    window.visualViewport.addEventListener('scroll', syncLogoPosition, { passive: true });
    window.visualViewport.addEventListener('resize', syncHeaderLayout, { passive: true });
  }

  window.addEventListener('scroll', syncLogoPosition, { passive: true });
  window.addEventListener('resize', syncHeaderLayout, { passive: true });
  window.addEventListener('load', syncHeaderLayout);
  document.addEventListener('shopify:section:load', syncHeaderLayout);
  document.addEventListener('shopify:section:reorder', syncHeaderLayout);
  document.addEventListener('shopify:block:select', syncHeaderLayout);

  window.setTimeout(syncHeaderLayout, 100);
  window.setTimeout(syncHeaderLayout, 500);
})();
